module.exports = __webpack_public_path__ + "media/images/writer/home/home-01@2x-1e432a5b719fb09d0a99b675ab4e5e88.png";